<template>
  <div>
    <b-form-group>
      <b-button
        :disabled="disabled"
        variant="outline-secondary"
        @click="showModal = true">
        <i class="fas fa-tag"></i>
        Tag Media
      </b-button>
      <br>
      {{ taggedMedia.length }} tagged
      <br>
    </b-form-group>

    <b-modal
      v-model="showModal"
      title="Media Library"
      centered hide-footer
      size="lg">
      <media-table
        v-if="showModal"
        :view="view"
        :ids-to-highlight="taggedMedia"
        :show-module-select="false"
        context="selectMany"
        @removeAll="removeAll"
        @selectMedia="addMediaRelation"/>
      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="showModal = false">
        Done Selecting
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mediaTable from './table'

export default {
  components: {
    mediaTable
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    initialMedia: {
      type: Array,
      required: true
    },
    namespace: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      taggedMedia: []
    }
  },
  computed: {
    ...mapState('groups', {
      view: '_defaultView'
    }),
    media () {
      return this.$store.getters['media/view'](this.view)
    }
  },
  mounted () {
    this.taggedMedia = this.initialMedia
    this.updateStore()
  },
  methods: {
    updateStore () {
      this.$store.commit(`${this.namespace}/forms/relateMedia/setField`, {
        field: 'mediaIDs',
        value: this.taggedMedia
      })
    },
    removeAll () {
      this.taggedMedia = []
      this.updateStore()
    },
    addMediaRelation (media) {
      // toggle inclusion of media
      let idx
      let exists = false
      for (let i=0; i<this.taggedMedia.length; i++) {
        if (this.taggedMedia[i] === media.id) {
          exists = true
          idx = i
        }
      }

      if (exists) {
        this.taggedMedia.splice(idx, 1)
      } else {
        this.taggedMedia.push(media.id)
      }

      this.updateStore()
    },
    reset (event) {
      this.taggedMedia = this.initialMedia
      this.$store.commit(`${this.namespace}/forms/relateMedia/resetState`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/media/relateMedia.vue